import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class DischargeForm extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      admissiondoctor: "",
      dischargediagnosis: "",
      timeOfRegistration: "",
      timeofdelivery: "",
      dateofdelivery: "",
      loading: false
      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });

    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    console.log(localStorage.getItem("currentVisitId"))
    console.log(this.api_url+""+localStorage.getItem('currentModule')+"/admission/main")
    axios
      .get(this.api_url+""+localStorage.getItem('currentModule')+"/admission/main", { headers: headers })
      .then((res) => {
        //   const verified = res.data;
        console.log(res.data)
        console.log("staff:"+res.data[0]['staffuserid']);
        this.setState({
          admissiondoctor: res.data[0]['staffuserid'],         
          timeOfRegistration:res.data[0]["timeOfRegistration"],
        });

      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
   
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+"reception/discharge/new",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        this.setState({
          loading: false
        })

        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          // window.location.href = '/delivery/apgar/score'
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });

    axios
      .post(
    
          this.api_url+"billing/status/" +
          localStorage.getItem("currentModule") +
          "/closed",
        this.state,
        { headers: headers }
      )
      .then((res) => {
        //   const verified = res.data;
        console.log(res.data);
        if (res.data["status"]) {
          $(".sendModuleSuccess").show();
          setTimeout(function (props) {
            $(".modal").hide();
            window.location.href = "/medical/home";
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    var PatientName = localStorage.getItem("currentVisitName");
    const {
      admissiondoctor,
      dischargediagnosis,
      timeOfRegistration,
      timeofdelivery,
      dateofdelivery,
      loading
    } = this.state;
    console.log(admissiondoctor)
    return (
      <div>
        <Headers />

        <InterModularSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    {PatientName}`s Discharge Form
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date and Time of Admission
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={timeOfRegistration}
                      name="timeOfRegistration"
                      readOnly
                    />
                  </div>
                  {/* <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Date Of Delivery</h6><input type="text" className="form-control" onChange={this.handleChange} value={dateofdelivery} name="dateofdelivery" readOnly />
                                    </div>
                                    <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}> Time Of Delivery</h6><input type="text" className="form-control" onChange={this.handleChange} value={timeofdelivery} name="timeofdelivery" readOnly />
                                    </div> */}
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Doctor of Admission
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={admissiondoctor}
                      name="admissiondoctor"
                      readOnly
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Discharge Diagnosis
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={dischargediagnosis}
                      name="dischargediagnosis"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default DischargeForm;
